import React from "react";

/**
 * Legend Component
 * 
 * Displays color-coded labels for node types.
 */
const Legend = () => {
  const legendItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
  };

  const legendBoxStyle = (bg, border) => ({
    width: "16px",
    height: "16px",
    backgroundColor: bg,
    border: `1px solid ${border}`,
    borderRadius: "2px",
  });

  const items = [
    { label: "Portal", bg: "#f3f4f6", border: "#d1d5db" },
    { label: "Topic", bg: "#fef9c3", border: "#fde047" },
    { label: "Category", bg: "#dcfce7", border: "#86efac" },
    { label: "Subcategory", bg: "#dbeafe", border: "#93c5fd" },
    { label: "Indicator", bg: "#f3e8ff", border: "#d8b4fe" },
  ];

  return (
    <div
      style={{
        marginTop: "16px",
        padding: "16px",
        backgroundColor: "#dbeafe",
        border: "1px solid #93c5fd",
        borderRadius: "4px",
      }}
    >
      <h3 style={{ fontWeight: 600, marginBottom: "8px" }}>Legend:</h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "8px",
        }}
      >
        {items.map((item) => (
          <div key={item.label} style={legendItemStyle}>
            <div style={legendBoxStyle(item.bg, item.border)} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend;
